import { render, staticRenderFns } from "./SiteVersionView.vue?vue&type=template&id=65038378&"
import script from "./SiteVersionView.vue?vue&type=script&lang=js&"
export * from "./SiteVersionView.vue?vue&type=script&lang=js&"
import style0 from "./SiteVersionView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports